/** PIN по умолчанию — 1309. Переопределение: VUE_APP_ADMIN_PIN в .env / CI. */
const DEFAULT_ADMIN_PIN = '1309';

export function getExpectedAdminPin() {
  const raw = process.env.VUE_APP_ADMIN_PIN;
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).trim();
  }
  return DEFAULT_ADMIN_PIN;
}

export function isAdminPinConfigured() {
  return getExpectedAdminPin().length > 0;
}
